import React, { useRef } from "react";
import { motion, useScroll, useTransform, useMotionTemplate } from "motion/react";

export const ScrollShadow = ({ 
  children, 
  className = "",
  baseOpacity = 0.2,
  direction = "110deg"
}: { 
  children: React.ReactNode, 
  className?: string,
  baseOpacity?: number,
  direction?: string
}) => {
  const ref = useRef<HTMLDivElement>(null);
  
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start 90%", "center 40%"]
  });

  const p1 = useTransform(scrollYProgress, [0, 1], [-50, 150]);
  const p2 = useTransform(scrollYProgress, [0, 1], [-30, 170]); 
  
  const maskImage = useMotionTemplate`linear-gradient(${direction}, #000 ${p1}%, rgba(0,0,0,${baseOpacity}) ${p2}%)`;

  return (
    <motion.div 
      ref={ref} 
      className={className}
      style={{ 
        "--mask-image": maskImage,
        WebkitMaskImage: "var(--mask-image)",
        maskImage: "var(--mask-image)"
      } as any}
    >
      {children}
    </motion.div>
  );
};
